<!-- 
  完成访客计划
 -->

<template>
  <div class="custome-plan">
    <el-dialog title="选择访客计划" :visible.sync="dialogVisible" :modal="false">
      <ul class="item-list" v-if="listData.length">
        <li class="item" :class="{checked: selectVisitPlanValue && selectVisitPlanValue.id===item.id}" v-for="item in listData" @click="handleCheck(item)">
          <div class="time">{{item.communicateTime}}</div>
          <dl class="desc">
            <dt class="title">{{item.value}}</dt>
            <dd class="memo">{{item.memo}}</dd>
            <dd class="contacts">
              <span class="contact" v-for="(u, i) in item.planUserArray" v-if="i<3">
                <img :src="u.userAvatar" :alt="u.userName">
                <span class="name">{{u.userName}}</span>
              </span>
              <i class="el-icon-more" v-if="item.planUserArray.length>3"></i>
            </dd>
          </dl>
        </li>
      </ul>
      <div v-else style="text-align:center">暂无访客计划</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="isItem" @click="itemSave">确定</el-button>
        <el-button type="primary" v-else @click="setStatusByIds">完成访客</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'

export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    selectVisitPlan: {
      type: Object,
      default: () => {}
    },
    isItem: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      selectVisitPlanValue: this.selectVisitPlan || {}
    }
  },
  mounted () {
    this.dialogVisible = true
  },
  methods: {
    // 选中操作
    handleCheck (item) {
      this.selectVisitPlanValue = {id: item.id, value: item.value}
    },
    // 提交
    setStatusByIds () {
      if (!this.selectVisitPlanValue.id) {
        Message({
          type: 'warning',
          message: '没有选中的数据！'
        })
        return
      }
      let url = '/communicatePlanApi/setStatusByIds.html'
      let params = {
        ids: [this.selectVisitPlanValue.id],
        status: 1
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功！'
        })
        this.dialogVisible = false
      })
    },
    itemSave () {
      this.$emit('visitPlanSave', this.selectVisitPlanValue)
      this.dialogVisible = false
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .custome-plan {
    .item-list {
      min-height: 300px;
      max-height: 500px;
      overflow: auto;
      padding: 5px;
      .item {
        margin-bottom: 20px;
        margin-top: 0;
        background-color: #fff;
        border-radius: 2px;
        box-sizing: border-box;
        display: flex;
        padding: 10px;
        position: relative;
        cursor: pointer;
        border: 2px solid #ddd;
        .time {
          width: 92px;
          flex: 0 0 auto;
          border-right: 1px dashed #e5ecf7;
          text-align: center;
          font-size: 24px;
          line-height: 54px;
        }
        .desc {
          padding-left: 15px;
          .title {
            font-size: 15px;
            color: #6a8ca4;
            font-weight: bold;
          }
          .memo {
            font-size: 13px;
            margin-top: 15px;
            color: #666;
          }
          .contacts {
            margin-top: 14px;
            .contact {
              display: inline-block;
              vertical-align: top;
              img {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                display: inline-block;
                vertical-align: top;
              }
              .name {
                display: inline-block;
                vertical-align: top;
                margin-left: 10px;
                line-height: 24px;
              }
            }
            .el-icon-more {
              vertical-align: top;
              line-height: 24px;
              margin-left: 15px;
            }
          }
        }
        &:hover {
          border-color: rgba(0, 140, 238, 0.5);
        }
        &.checked {
          border-color: rgba(0, 140, 238, 0.5);
          &:after {
            font-family: 'web-iconfont';
            font-size: 12px;
            content: "\e686";
            position: absolute;
            right: 0;
            top: 0;
            padding: 5px 10px;
            background-color: rgba(0, 140, 238, 0.5);
            color: #fff;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// customer-plan.vue?5368794a